/**
 * Normalize metric values to 0–1 for bar/pill fill display.
 *
 * - perCycle: normalizes relative to the highest value in the array.
 * - perDay:   normalizes each value relative to targetValue.
 */
export function normalizeMetricValues(
  metricValues: number[] | undefined | null,
  targetValue: number,
  metricPeriod: string
): number[] {
  if (!metricValues?.length) return [];

  if (metricPeriod === 'perCycle') {
    let highValue = 0;
    for (const value of metricValues) {
      if (value > highValue) {
        highValue = value;
      }
    }
    if (highValue === 0) return metricValues.map(() => 0);
    return metricValues.map(value => Math.min(value / highValue, 1));
  }

  if (targetValue === 0) return metricValues.map(() => 0);
  return metricValues.map(value => Math.min(value / targetValue, 1));
}
